export const createAzureAuthorizationUrl = (args: { organizationName: string; organizationId: string; }) => {
	const clientId = process.env.REACT_APP_MICROSOFT_ENTRA_ID_CLIENT_ID as string;
	const scopes = process.env.REACT_APP_MICROSOFT_ENTRA_SCOPES as string;
	const redirectUri = process.env.REACT_APP_FIREBASE_AUTH_CALLBACK_URL as string;
	const url = new URL('https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize');

	url.searchParams.set('client_id', clientId);
	url.searchParams.set('response_type', 'code');
	url.searchParams.set('response_mode', 'query');
	url.searchParams.set('redirect_uri', redirectUri);
	url.searchParams.set('state', `${args.organizationName};${args.organizationId}`);
	url.searchParams.set('scope', scopes);

	return url.toString();
};

export const appgamiAutomationAuthorizationUrl = (args: { organizationName: string; organizationId: string; }) => {
	const webUrl = process.env.REACT_APP_WEB_APP_URL as string;
	return `${webUrl}/index.html/user-authorization?organization_name=${args.organizationName}&organization_id=${args.organizationId}`;
};